import router from './router'
import store from './store'
import { Message } from 'element-ui'
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css'// progress bar style
import { getToken } from '@/utils/auth' // getToken from cookie
// chromeMsg()
// function chromeMsg() {
//   if (window.navigator.userAgent.indexOf('Chrome') < 0) {
//     MessageBox.confirm('本系统推荐使用Chrome浏览器，确定自动下载浏览器，取消忽略本提示！', '提示', {
//       confirmButtonText: '确定',
//       cancelButtonText: '取消',
//       type: 'info'
//     }).then(() => {
//       if (window.navigator.userAgent.indexOf('Windows NT 5') !== -1) {
//         window.open('http://img.rimag.com.cn/help/download/49.0.2623.112_chrome_installer.exe')
//       } else if (window.navigator.userAgent.indexOf('Mac OS') !== -1) {
//         window.open('http://img.rimag.com.cn/help/download/50.0.2661.102_chrome_installer.dmg')
//       } else {
//         window.open('http://img.rimag.com.cn/help/download/55.0.2883.75_chrome_installer.exe')
//       }
//     }).catch(() => {
//       Message({
//         type: 'success',
//         message: '已取消'
//       })
//     })
//   }
// }
NProgress.configure({ showSpinner: false })// NProgress Configuration
const whiteList = ['/login', '/resetpwd']// no redirect whitelist
router.beforeEach((to, from, next) => {
  NProgress.start() // start progress bar
  if (getToken()) { // determine if there has token
    /* has token*/
    if (to.path === '/login') {
      next({ path: '/' })
      NProgress.done() // if current page is dashboard will not trigger	afterEach hook, so manually handle it
    } else {
      if (store.getters.roles.length === 0) { // 判断当前用户是否已拉取完user_info信息
        store.dispatch('GetInfo').then(res => { // 拉取user_info
          const { data = {}} = res
          const { roleModule = '' } = data.userInfo.currentUserRoleDepart
          store.dispatch('GenerateRoutes', { roleModule }).then(() => {}) // 根据roles权限生成可访问的路由表
          // console.log(store.getters.addRouters)
          router.addRoutes(store.getters.addRouters) // 动态添加可访问路由表
          next({ ...to, replace: true }) // hack方法 确保addRoutes已完成 ,set the replace: true so the navigation will not leave a history record
        }).catch((err) => {
          store.dispatch('FedLogOut').then(() => {
            Message.error(err || 'Verification failed, please login again')
            next({ path: '/' })
          })
        })
      } else {
        next()
      }
    }
  } else {
    /* has no token*/
    if (whiteList.indexOf(to.path) !== -1) { // 在免登录白名单，直接进入
      next()
    } else {
      next('/login') // 否则全部重定向到登录页
      NProgress.done() // if current page is login will not trigger afterEach hook, so manually handle it
    }
  }
})

router.afterEach(() => {
  NProgress.done() // finish progress bar
})
